import { useDialog } from '@react-aria/dialog';
import { useModal, useOverlay } from '@react-aria/overlays';
import { mergeProps } from '@react-aria/utils';
import { Grid2 } from '@riac/design-system';
import React, { useRef } from 'react';

export const MegaMenu = ({ onClose, isOpen, children }: {onClose: () => void, isOpen: boolean, children: React.ReactNode}) => {
  const ref = useRef(null!);
  const { overlayProps } = useOverlay({
    onClose,
    isOpen,
    isDismissable: true,
    shouldCloseOnBlur: false,
    shouldCloseOnInteractOutside: (element: HTMLElement) => {
      if(element.closest('[data-dont-close-mega-menu="true"]')) {
        return false;
      }
      if(element.closest('[data-allow-press-while-closing-mega-menu="true"]')) {
        setTimeout(() => onClose(), 100);
        return false;
      }
      return true;
    },
  }, ref);
  const { dialogProps } = useDialog({}, ref);
  const { modalProps } = useModal();

  return (
    <>
      <div
        {...mergeProps(overlayProps, dialogProps, modalProps)} ref={ref}
        className={'absolute z-50 border-t-2 border-accent right-0 top-full bg-surface-dark w-full focus:outline-0'}
        style={{
          boxShadow: '0px 4px 10px 0.4px #1717174D',

        }}
      >
        <Grid2 className='py-0' id='mega-menu-container'>
          {children}
        </Grid2>
      </div>
      <div className='absolute z-40 right-0 top-0 left-0 bottom-0 h-screen bg-[#40404052]' id='mega-menu-scrim' />
    </>
  );
};
